var $edce3ce0bbac84b4$exports = {};
$edce3ce0bbac84b4$exports = {
    "Clear search": `Effacer la recherche`
};


export {$edce3ce0bbac84b4$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
